// pages/Dashboard.jsx
import HomeLayout from "../../components/home/HomeLayout";
import MembershipPlans from "../../components/home/MembershipPlans";

export default function Dashboard() {
  return (
    <HomeLayout>
      <MembershipPlans />
    </HomeLayout>
  );
}
